export default __webpack_public_path__ + "static/media/logo2.db64d519.svg";